// Forecast Studio design tokens — the green-heritage skin, exact values from
// the handoff design system (doc 02) and tailwind.config.ts. The Forecast
// Studio screens are built with inline style objects keyed off these tokens
// (matching the reference prototype 1:1) rather than Tailwind classes, so the
// transcription is unambiguous. Do not invent or round new values.

export const C = {
  parchment: '#f5f1ea', paper: '#faf7f0', card: '#ffffff',
  ink: '#1a1a1a', inkSoft: '#5a5a5a', inkFaint: '#8a8574',
  line: '#d8d2c4', lineSoft: '#e7e1d5',
  green: '#0a4a3a', greenDk: '#14322a', greenSoft: '#dcebe5', greenBg: '#eef5f1',
  brass: '#9b7f2a', brassDk: '#7a540b', brassLt: '#c9a13a', brassSoft: '#f5edd5', brassBg: '#faf3dd',
  oxblood: '#7a2329', oxbloodSoft: '#f8dbdd',
  slate: '#3d5a6c', slateSoft: '#e0e7ec',
  amber: '#c98a4e', amberSoft: '#faeadb'
} as const

export const F = {
  serif: "'Playfair Display',Georgia,serif",
  body: "'Source Sans 3',system-ui,sans-serif",
  mono: "'IBM Plex Mono',ui-monospace,monospace"
} as const

// Departments — shared by both apps (doc 02 §2). Key is the stable slug.
export const DEPTS: Record<string, { name: string; short: string; fg: string; bg: string }> = {
  events: { name: 'Events', short: 'EVT', fg: '#0a4a3a', bg: '#dcebe5' },
  ops: { name: 'Operations', short: 'OPS', fg: '#3d5a6c', bg: '#e0e7ec' },
  mpd: { name: 'Motive Power', short: 'MPD', fg: '#7a540b', bg: '#f5edd5' },
  cw: { name: 'Carriage & Wagon', short: 'C&W', fg: '#56406a', bg: '#ece0f2' },
  commercial: { name: 'Commercial', short: 'COMM', fg: '#9b7f2a', bg: '#faf3dd' },
  marketing: { name: 'Marketing', short: 'MKT', fg: '#c98a4e', bg: '#faeadb' },
  catering: { name: 'Catering & Retail', short: 'CAT', fg: '#92384f', bg: '#f6dde3' },
  finance: { name: 'Finance', short: 'FIN', fg: '#0a4a3a', bg: '#dcebe5' },
  hs: { name: 'Health & Safety', short: 'H&S', fg: '#7a2329', bg: '#f8dbdd' },
  people: { name: 'Volunteering', short: 'VOL', fg: '#3d5a6c', bg: '#e0e7ec' }
}

export const DEPT_KEYS = Object.keys(DEPTS)

// Running-timetable types (from The Big Plan TtTimetable patterns) — used by
// the proposed-slot card to colour each day.
export const TTX: Record<string, { label: string; dot: string; bg: string; fg: string }> = {
  blue: { label: 'Blue Timetable', dot: '#2B7A8C', bg: '#D8E8EB', fg: '#2B5A66' },
  red: { label: 'Red Timetable', dot: '#B83A2B', bg: '#F6D9D2', fg: '#8A2A1F' },
  pink: { label: 'Pink Timetable', dot: '#C25F94', bg: '#F4DCEA', fg: '#8A3A66' },
  event: { label: 'Special Event', dot: '#7A5D8C', bg: '#EAE2F4', fg: '#6A4A86' },
  none: { label: 'No Service', dot: '#C2B391', bg: '#F1E9D6', fg: '#9F8B6B' }
}
